import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugin/element'
import './plugin/swiper'
import './plugin/secret'
import './plugin/request'
import './plugin/map'
import './plugin/metaInfo'

import './style/base.css'

Vue.config.productionTip = false

Vue.prototype.$second = 60;

// Vue.prototype._link = 'http://bixin.pro6.liuniukeji.net/index.html#/';

/*Vue.prototype._link = 'http://bxyl.pro6.liuniukeji.net/'

Vue.prototype.$link = 'http://bxylh5.pro6.liuniukeji.net'*/

// Vue.prototype._link = process.env.VUE_APP_URL

// Vue.prototype.$link = process.env.VUE_APP_MOBILE_URL

Vue.prototype._link = 'http://www.wenyule.cn/'

Vue.prototype.$link = 'http://mobile.wenyule.cn'



// 判断是否登录
Vue.prototype.$isLogin = function () {
  let userinfo = JSON.parse(this.$Decrypt(localStorage.getItem('userinfo') || '') || '{}') || {};
  return userinfo.token ? true : false;
};

// 获取用户信息
Vue.prototype.$getUserinfo = function () {
  let userinfo = JSON.parse(this.$Decrypt(localStorage.getItem('userinfo') || '') || '{}') || {};
  return userinfo;
}

// 获取用户token
Vue.prototype.$getToken = function () {
  let userinfo = JSON.parse(this.$Decrypt(localStorage.getItem('userinfo') || '{}') || '{}') || {};
  return userinfo.token || '';
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
